if (!customElements.get('laerke-size-chart')) {
  customElements.define('laerke-size-chart', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-chart-open]');
      if (!dialog || !trigger) return;
      this.dialog = dialog;
      trigger.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal();
        dialog.scrollTop = 0;
        this.scrollEntries.forEach(({ area }) => { area.scrollLeft = 0; });
        this.updateScroll();
      }, options);
      this.querySelector('[data-chart-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      }, options);
      this.scrollEntries = Array.from(this.querySelectorAll('.laerke-size-chart__section')).map(section => ({
        area: section.querySelector('.laerke-size-chart__scroll'),
        range: section.querySelector('[data-chart-scroll]'),
        controls: section.querySelector('.laerke-size-chart__scroll-controls'),
        hint: section.querySelector('.laerke-size-chart__scroll-hint')
      })).filter(entry => entry.area && entry.range && entry.controls && entry.hint);
      this.resizeObserver = new ResizeObserver(() => this.updateScroll());
      this.scrollEntries.forEach(({ area, range }) => {
        area.addEventListener('scroll', () => this.updateScroll(), { ...options, passive: true });
        range.addEventListener('input', () => {
          area.scrollLeft = (area.scrollWidth - area.clientWidth) * Number(range.value) / 100;
        }, options);
        this.resizeObserver.observe(area);
        const table = area.querySelector('table');
        if (table) this.resizeObserver.observe(table);
      });
      this.querySelectorAll('[data-chart-unit]').forEach(button => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-chart-unit]').forEach(unit => unit.setAttribute('aria-pressed', String(unit === button)));
          this.querySelectorAll('[data-chart-panel]').forEach(panel => { panel.hidden = panel.dataset.chartPanel !== button.dataset.chartUnit; });
          this.updateScroll();
        }, options);
      });
    }
    updateScroll() {
      if (!this.dialog?.open) return;
      this.scrollEntries.forEach(({ area, range, controls, hint }) => {
        const distance = area.scrollWidth - area.clientWidth;
        const overflowing = area.clientWidth > 0 && distance > 1;
        controls.hidden = !overflowing;
        hint.hidden = !overflowing;
        range.value = overflowing ? String(area.scrollLeft / distance * 100) : '0';
        range.style.setProperty('--chart-thumb-size', Math.max(32, area.clientWidth * area.clientWidth / Math.max(1, area.scrollWidth)) + 'px');
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
